export const USER_LOGIN = (state, data) => {
  state.name = data.name
  state.roles = data.roles
  state.token = data.token
  state.orgas = data.organisationseinheiten
  state.fisPersid = data.fisPersid
  state.email = data.email
  state.forscher = data.forscher

  // set fisPersid for profileViewState
  let profileViewState = state.activeViewStates.find((activeViewState) => activeViewState.id === 'profile')
  if (profileViewState) {
    profileViewState.route.params.id = data.fisPersid
  }
}

export const USER_LOGOUT = (state) => {
  state.name = null
  state.roles = []
  state.token = null
  state.orgas = null
  state.fisPersid = null
  state.email = null
  state.forscher = null
  state.selectedOrgaID = null
}

export const CHANGE_ORGA = (state, data) => {
  state.activeOrga = data
  state.selectedOrgaID = state.orgas[state.activeOrga]._id
}

export const LOADING_START = (state) => {
  state.loading = true
}

export const LOADING_DONE = (state) => {
  state.loading = false
}

export const SAVE_VIEW = (state, viewConfiguration) => {
  let id = 1
  if (state.savedViews.length > 0) {
    id = state.savedViews.slice(-1)[0].id + 1
  }
  state.savedViews.push({id, ...viewConfiguration})
}

export const DELETE_VIEW = (state, id) => {
  const index = state.savedViews.findIndex(x => x.id === id)
  state.savedViews.splice(index, 1)
}

export const ACTIVE_VIEW_STATE = (state, id) => {
  state.activeViewState = id
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js